import Page from "../../components/Page"
import ClaimUSTForm from "../../forms/ClaimUSTForm"

const ClaimUST = () => {
  return (
    <Page>
      <ClaimUSTForm />
    </Page>
  )
}

export default ClaimUST
